"use client";

import { c as _c } from "react/compiler-runtime";
import { InputHTMLAttributes } from "react";
interface RadioButtonProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  name: string;
  checked?: boolean;
  id: string;
}
export default function RadioButton(t0) {
  const $ = _c(17);
  let checked;
  let id;
  let label;
  let name;
  let props;
  if ($[0] !== t0) {
    ({
      label,
      name,
      id,
      checked,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = id;
    $[3] = label;
    $[4] = name;
    $[5] = props;
  } else {
    checked = $[1];
    id = $[2];
    label = $[3];
    name = $[4];
    props = $[5];
  }
  let t1;
  if ($[6] !== checked || $[7] !== id || $[8] !== name || $[9] !== props) {
    t1 = <input id={id} name={name} type="radio" className="peer sr-only radio" checked={checked} {...props} />;
    $[6] = checked;
    $[7] = id;
    $[8] = name;
    $[9] = props;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-4 h-4 rounded-full border border-gray-400 flex items-center justify-center peer-checked:border-primary dark:border-gray-600 relative"><div className="w-2 h-2 bg-primary rounded-full opacity-0 transition-opacity duration-200 peer-checked:opacity-100" /></div>;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== label) {
    t3 = <span className="text-sm text-gray-800 dark:text-gray-200">{label}</span>;
    $[12] = label;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t1 || $[15] !== t3) {
    t4 = <label className="flex items-center gap-2 cursor-pointer select-none">{t1}{t2}{t3}</label>;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}